export { default } from './LazyPhoto';
